import { Option } from "@/components/AsyncSelect/AsyncSelect";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";
import StoreGroupSelect from "@/components/StoreGroupSelect";
import { noop } from "@/lib/noop";
import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

interface StoreGroupFilterProps {
  inDialog?: boolean;
  className?: string;
}

const StoreGroupFilter = ({ inDialog, className }: StoreGroupFilterProps) => {
  const { options } = useDataTableSettings();
  const value = options.getFilterValue("store_group_id")?.value;
  const [selectedItem, setSelectedItem] = useState<Option | undefined>();

  useEffect(() => {
    if (value === undefined) {
      setSelectedItem(undefined);
    }
  }, [value]);

  const handleChange = useCallback(
    (nextValue: string | undefined, option?: Option) => {
      if (!nextValue || nextValue === value) {
        setSelectedItem(undefined);
        options.resetFilterById("store_group_id");
        return;
      }
      setSelectedItem(option);
      options.setFilterValue("store_group_id", { value: nextValue });
    },
    [options, value],
  );

  return (
    <div
      className={cn(
        "flex flex-row gap-2 items-center justify-center",
        className,
      )}
    >
      <StoreGroupSelect
        value={value}
        onChange={handleChange}
        onBlur={noop}
        name="store_group_id"
        inDialog={inDialog}
        showLink={false}
        className={cn({
          "bg-blue-100 border-blue-300 text-blue-700": value !== undefined,
        })}
        allowClearSelection
        defaultItem={selectedItem}
      />
    </div>
  );
};

export default StoreGroupFilter;
